import script from "./AppTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTab.vue?vue&type=script&setup=true&lang=ts"

import "./AppTab.vue?vue&type=style&index=0&id=02dff34e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02dff34e"]])

export default __exports__